import tw from 'twin.macro';

export const Wrapper = tw.div`
relative flex-1 pr-5 flex z-50 
lg:([flex: unset] pr-0)
`;
